ixModuleRouting("impactx.productlist", {
    "/recentlyviewed": {
        templateUrl: "modules/product/templates/productlist.tmpl.html",
        controller: "RecentlyViewedProductsCtrl",
        process: "ProductList",
        workspace: "shop",
    },
    "/newproducts": {
        templateUrl: "modules/product/templates/productlist.tmpl.html",
        controller: "NewProductsCtrl",
        controllerAs: "ctrl",
        process: "ProductList",
        workspace: "shop",
    },
    "/orderedproducts": {
        templateUrl: "modules/product/templates/productlist.tmpl.html",
        controller: "OrderedProductsCtrl",
        controllerAs: "ctrl",
        process: "ProductList",
        workspace: "shop",
    },
    "/lastorderedproducts": {
        templateUrl: "modules/product/templates/productlist.tmpl.html",
        controller: "LastOrderedProductsCtrl",
        controllerAs: "ctrl",
        process: "ProductList",
        workspace: "shop",
    },
    "/recommendedproducts": {
        templateUrl: "modules/product/templates/productlist.tmpl.html",
        controller: "RecommendedProductsCtrl",
        controllerAs: "ctrl",
        process: "ProductList",
        workspace: "shop",
    },
});
